import React, { useState, useEffect } from 'react';

export default function Hero() {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden px-4">
      {/* Deep Charcoal Background */}
      <div className="absolute inset-0 bg-deep-charcoal">
        <div 
          className="absolute inset-0 opacity-5"
          style={{
            backgroundImage: `radial-gradient(circle at 2px 2px, rgba(247,231,173,0.1) 1px, transparent 0)`,
            backgroundSize: '30px 30px'
          }}
        ></div>
        {/* Subtle gradient overlay for depth */}
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-black/10"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 text-center max-w-4xl mx-auto w-full">
        <div className="mb-6 md:mb-8 flex flex-col items-center justify-center">
          <h1 className={`text-4xl sm:text-5xl md:text-6xl lg:text-8xl xl:text-9xl font-black tracking-tight mb-2 md:mb-4 transition-all duration-1000 leading-tight ${isLoaded ? 'opacity-100 transform translate-y-0' : 'opacity-0 transform translate-y-8'}`}>
            <div className="block sm:inline">
              <span 
                className="drop-shadow-2xl"
                style={{
                  background: 'linear-gradient(135deg, #FFD700 0%, #FFA500 25%, #FFD700 50%, #B8860B 75%, #DAA520 100%)',
                  WebkitBackgroundClip: 'text',
                  backgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundImage: 'linear-gradient(135deg, #FFD700 0%, #FFA500 25%, #FFD700 50%, #B8860B 75%, #DAA520 100%)',
                  filter: 'drop-shadow(0 0 10px rgba(255, 215, 0, 0.3))'
                }}
              >
                WORLD
              </span>
              <span 
                className="drop-shadow-2xl ml-2 sm:ml-4"
                style={{
                  background: 'linear-gradient(135deg, #C0C0C0 0%, #FFD700 25%, #C0C0C0 50%, #B8860B 75%, #FFD700 100%)',
                  WebkitBackgroundClip: 'text',
                  backgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundImage: 'linear-gradient(135deg, #C0C0C0 0%, #FFD700 25%, #C0C0C0 50%, #B8860B 75%, #FFD700 100%)',
                  filter: 'drop-shadow(0 0 10px rgba(192, 192, 192, 0.3))'
                }}
              >
                TITLE
              </span>
            </div>
            <div className="block sm:inline">
              <span 
                className="drop-shadow-2xl"
                style={{
                  background: 'linear-gradient(135deg, #B8860B 0%, #FFD700 25%, #CD853F 50%, #DAA520 75%, #FFD700 100%)',
                  WebkitBackgroundClip: 'text',
                  backgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundImage: 'linear-gradient(135deg, #B8860B 0%, #FFD700 25%, #CD853F 50%, #DAA520 75%, #FFD700 100%)',
                  filter: 'drop-shadow(0 0 10px rgba(184, 134, 11, 0.3))'
                }}
              >
                FIGHT
              </span>
              <span 
                className="drop-shadow-2xl"
                style={{
                  background: 'linear-gradient(135deg, #FFD700 0%, #FFA500 25%, #DAA520 50%, #B8860B 75%, #FFD700 100%)',
                  WebkitBackgroundClip: 'text',
                  backgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundImage: 'linear-gradient(135deg, #FFD700 0%, #FFA500 25%, #DAA520 50%, #B8860B 75%, #FFD700 100%)',
                  filter: 'drop-shadow(0 0 10px rgba(255, 215, 0, 0.3))'
                }}
              >
                .COM
              </span>
            </div>
          </h1>
        </div>

        <div className="space-y-4 md:space-y-6">
          <p className="text-lg md:text-xl lg:text-2xl text-gray-300 max-w-2xl mx-auto leading-relaxed drop-shadow-md px-4 font-light">
            The Ultimate Domain for Combat Sports Excellence
          </p>
          
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4 text-base md:text-lg">
            <div className="flex items-center gap-2">
              <span className="w-3 h-3 bg-champagne-gold rounded-full animate-pulse"></span>
              <span className="text-champagne-gold font-semibold drop-shadow-md tracking-wide">PREMIUM DOMAIN</span>
            </div>
            <div className="flex items-center gap-2">
              <span className="w-3 h-3 bg-white rounded-full animate-pulse"></span>
              <span className="text-white font-semibold drop-shadow-md tracking-wide">FOR SALE</span>
            </div>
          </div>

          <div className="mt-8 md:mt-12 px-4">
            <a 
              href="#contact" 
              className="inline-block bg-champagne-gold hover:bg-yellow-300 text-deep-charcoal font-bold py-3 px-3 md:py-4 md:px-4 rounded-lg text-lg md:text-xl transition-all duration-300 cursor-pointer shadow-lg hover:shadow-xl border border-champagne-gold/30 min-h-[48px] flex items-center justify-center tracking-wide"
            >
              MAKE AN OFFER
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}